module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-17.59cd7163.png";